import styled, { css } from 'styled-components';
import { Icon } from '../Icon/Icon';
import type { InputButtonStyledProps } from './Datepicker.typed';
import { ButtonStyledProps } from './Datepicker.typed';

export const Wrapper = styled.div(
  ({ theme }) => css`
    .react-datepicker {
      width: 250px;
      background: #fff;
      border: 1px solid #d9d9d9;
      border-radius: ${theme.borderRadius.s};
      overflow: hidden;
      font-size: ${theme.typography.fontSizes.M14};

      &-popper {
        z-index: 1;
      }

      &__aria-live {
        position: absolute;
        clip-path: circle(0);
        border: 0;
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        width: 1px;
        white-space: nowrap;
      }
      &__header {
        padding: ${`${theme.spacing.S4} ${theme.spacing.S4} ${theme.spacing.M16}`};
        background: #f2f2f2;
      }
      &__day-names {
        display: flex;
        justify-content: center;
        gap: ${theme.spacing.S8};
      }
      &__day-name {
        width: 24px;
        color: #333;
      }
      &__month {
        padding: ${theme.spacing.M16};
      }
      &__week {
        display: flex;
        justify-content: center;
        gap: ${theme.spacing.S8};
        margin-bottom: ${theme.spacing.S8};

        &:last-of-type {
          margin-bottom: 0;
        }
      }
      &__day {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        color: #333;
        border-radius: ${theme.borderRadius.s};
        cursor: pointer;

        &:hover {
          background: #f2f2f2;
        }
        &--today {
          background: #f2f2f2;
        }
        &--selected {
          background: ${theme.brand.primary.base} !important;
          color: #fff;
        }
        &--outside-month {
          visibility: hidden;
        }
      }
    }
  `,
);
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.S12};
`;
export const SelectGroup = styled.div`
  flex: 0 1 auto;
  display: flex;
  gap: ${({ theme }) => theme.spacing.S8};
`;
export const SelectWrapper = styled.div`
  position: relative;
  flex: 0 1 auto;
`;
export const Select = styled.select`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 100%;
  padding: ${({ theme }) =>
    `${theme.spacing.S12} ${theme.spacing.M16} ${theme.spacing.S12} 0`};
  appearance: none;
  background: none;
  border: none;
  color: #333;
`;
export const SelectIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  pointer-events: none;
`;
/**
 * Used to adjust the width of the select element based on selected value
 */
export const SelectedValue = styled.div`
  visibility: hidden;
  display: inline-block;
  padding-right: ${({ theme }) => theme.spacing.M16};
`;
export const MonthButton = styled.button`
  padding: ${({ theme }) => theme.spacing.S12};
`;
export const InputButton = styled.button<InputButtonStyledProps>`
  width: 100%;
  height: 100%;
  padding: 0 ${({ theme }) => theme.spacing.S8};
  color: ${({ theme, hasError, isDisabled }) =>
    isDisabled
      ? '#999'
      : hasError
      ? theme.brand.error.base
      : theme.brand.primary.base};
`;
export const Button = styled.button<ButtonStyledProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px; // TODO: use theme size
  padding-left: ${({ theme }) => theme.spacing.M16};
  padding-right: ${({ theme }) => theme.spacing.S12};
  text-align: left;
  background: #fff; // TODO: use theme color
  border: 1px solid #999; // TODO: use theme color
  border-radius: 4px; // TODO: use theme border radius
  color: #333; // TODO: use theme color

  &:focus {
    border-color: #953fff;
    outline: none;
  }

  ${({ hasError, theme }) =>
    hasError &&
    css`
      color: ${theme.brand.error.base};
      border-color: ${theme.brand.error.base};
    `}

  ${({ hasValue }) =>
    !hasValue &&
    css`
      color: #999; // TODO: use theme color
    `}
  
  

  &:disabled {
    background-color: #f2f2f2; // TODO: use theme color
    border-color: #d9d9d9; // TODO: use theme color
    color: #999; // TODO: use theme color
  }
`;
